export default __webpack_public_path__ + "static/media/Bella Zhong.d921275c.png";